import Cookies from 'js-cookie';

function existingTicketsController($scope, $rootScope, $route, $location, $routeParams, $translate, MyTicketsMonthYearSvc) {
    "ngInject";
    $scope.LoadPage = false;
    var locationChange = false;

    jQuery(document).ready(function ($) {        
        MyTicketsMonthYearSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), Year: $scope.CurrentYear, Month: $scope.CurrentMonth }, function (data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].DrawsRemaining == 0) {
                    locationChange = true;
                    $location.url($location.path('/tickets').replace());
                    $location.path('/tickets').replace();
                }
            }
            if (!locationChange)
                $scope.LoadPage = true;
        });
    });

};

export default {
    name: 'existingTicketsController',
    fn: existingTicketsController
}